import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = {
  id: string;
  attorneyName: string;
  prospectName: string;
  prospectEmail: string;
  slotStart: string;
  slotEnd: string;
  status: string;
  calendarProvider: string;
};

export default function BookingsPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ bookings: Row[] }>("/api/v1/tenant/bookings");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("bookings.title")}</h1>
      <DataTable
        rows={data?.bookings ?? null}
        loading={loading}
        error={error}
        empty={t("bookings.empty")}
        columns={[
          { header: t("bookings.col.attorney"), render: (r) => r.attorneyName },
          {
            header: t("bookings.col.prospect"),
            render: (r) => (
              <span>
                {r.prospectName}
                <span className="block text-xs text-slate-400">{r.prospectEmail}</span>
              </span>
            ),
          },
          {
            header: t("bookings.col.slot"),
            render: (r) => new Date(r.slotStart).toLocaleString(),
          },
          { header: t("bookings.col.status"), render: (r) => r.status },
          { header: t("bookings.col.provider"), render: (r) => r.calendarProvider || "—" },
        ]}
      />
    </div>
  );
}
